import wx from 'weixin-js-sdk';
import { getWxTicket, login } from '@/service/api';
import { showFailToast} from "vant";
import { useStore } from "vuex";

const appId = 'wxf8e2a96c89a168cb';  // 正式
// const appId = 'wx4872085d222a6bd5';  //测试用

export function wxAuth() {
  return new Promise((resolve, reject) => {
    const store = useStore();
    if (store.getters.hasLogin) {
      resolve();
      return;
    }
    const url = window.location.search;
    const params = new URLSearchParams(url);
    const code = params.get('code');
    if (!code) {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(window.location.href)}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
      return;
    }
    login({ code }).then((res) => {
      console.log(res);
      if (res.token) {
        localStorage.setItem('token', `Bearer ${res.token}`);
        store.commit('setToken', `Bearer ${res.token}`);
        // 清理 URL 中的 code 参数
        const url = new URL(window.location.href);
        url.searchParams.delete('code');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
        resolve();
      }
    }).catch((err) => {
      showFailToast(err);
      reject();
    })
  })
}

// 微信配置状态缓存
let wxConfigPromise = null;
let isWxReady = false;

/**
 * 初始化设置
 */
export async function goWxConfig() {
  // 如果已经配置成功，直接返回
  if (isWxReady) {
    return Promise.resolve(true);
  }
  
  // 如果正在配置中，返回现有的 Promise
  if (wxConfigPromise) {
    return wxConfigPromise;
  }
  
  wxConfigPromise = new Promise((resolve, reject) => {
    console.log('执行注册微信config');
    try {
      getWxTicket({
        url: window.location.href.split('#')[0],
      })
        .then(res => {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            beta: false,
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: [
              'updateAppMessageShareData',
            ], // 必填，需要使用的JS接口列表
          });
        })
        .catch(err => {
          console.log('微信鉴权失败', err);
          wxConfigPromise = null; // 重置，允许重试
          reject(err);
        });

      wx.ready(function () {
        console.log('wx ready');
        isWxReady = true;
        resolve(true);
      });
      wx.error(function (err) {
        console.log('wx error', err);
        wxConfigPromise = null; // 重置，允许重试
        // config信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的debug模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名。
        reject(err);
      });
    } catch (error) {
      console.warn('微信config报错：', error);
      wxConfigPromise = null; // 重置，允许重试
      reject(error);
    }
  });
  
  return wxConfigPromise;
}

export function useWxShare(config) {
  goWxConfig()
    .then(() => {
      wx.checkJsApi({
        jsApiList: ['updateAppMessageShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function (res) {
          console.log(res);
          // 以键值对的形式返回，可用的api值true，不可用为false
          if (res.checkResult && res.checkResult.updateAppMessageShareData) {
            wx.updateAppMessageShareData({
              title: config.title || '', // 分享标题
              desc: config.desc || '', // 分享描述
              link: config.link || '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: config.imgUrl || '', // 分享图标
              success: function() {
                console.log('分享配置成功');
                if (config.success) {
                  config.success();
                }
              },
              cancel: function() {
                console.log('取消分享');
                if (config.cancel) {
                  config.cancel();
                }
              },
              fail: function(err) {
                console.error('分享配置失败', err);
                if (config.fail) {
                  config.fail(err);
                }
              }
            });
          } else {
            console.warn('微信分享接口不可用');
            if (config.fail) {
              config.fail(new Error('微信分享接口不可用'));
            }
          }
        },
        fail: function(err) {
          console.error('checkJsApi 失败', err);
          if (config.fail) {
            config.fail(err);
          }
        }
      });
    })
    .catch((err) => {
      console.error('微信配置失败', err);
      if (config.fail) {
        config.fail(err);
      }
    });
}

/**
 * 支付
 */
export function useWxPay(config) {
  return new Promise((resolve, reject) => {
    function onBridgeReady() {
      WeixinJSBridge.invoke('getBrandWCPayRequest', {
        appId: config.appId,     //公众号ID，由商户传入     
        timeStamp: config.timeStamp,     //时间戳，自1970年以来的秒数     
        nonceStr: config.nonceStr,      //随机串     
        package: config.packageData,
        signType: config.signType,     //微信签名方式：     
        paySign: config.signInfo //微信签名 
      }, function (res) {
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          resolve();
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        } else if(res.err_msg == 'get_brand_wcpay_request:cancel') {
          showFailToast('支付取消');
          reject(res);
        }else if(res.err_msg == 'get_brand_wcpay_request:fail') {
          showFailToast('支付失败');
          reject(res);
        }else {
          showFailToast('支付异常');
        }
      });
    }
    if (typeof WeixinJSBridge == "undefined") {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
    } else {
      onBridgeReady();
    }
  })
}
